var prodcat;
var site;

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product-full', function (e, skuBaseId, hasDramming) {
    var $product = $(this);
    var $shadesGrid = $product.find('.js-product-full-shades-grid');
    var $shadesList = $product.find('.js-product-full-shades-list');
    var $shadeArrayItem = $('.js-product-full-shades-array-item', $product);
    var $selectedListItem;
    var $selectedShade;

    // Don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }

    if (typeof skuBaseId === 'undefined') {
      skuBaseId = prodcat.ui.getSkuIdByProduct($(this));
    }
    $selectedShade = $shadesGrid.find(
      '.js-product-full-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
    );
    $selectedListItem = $shadesList.find(
      '.js-product-full-shades-overlay-list-item[data-sku-base-id="' + skuBaseId + '"]'
    );

    if ($shadesGrid.length < 1) {
      return null;
    }
    $product.attr('data-sku-base-id', skuBaseId);

    if (hasDramming) {
      $('.js-product-full-shades-grid-item.secondactive', $product).removeClass(
        'active secondactive'
      );
      $selectedShade.addClass('active secondactive');
    } else {
      $shadeArrayItem.not('.secondactive').removeClass('active');
      $selectedListItem.addClass('active');
      $selectedShade.addClass('active');
    }
  });
  $(document).on('inv_status_display:updated', '.js-product-full', function () {
    var $product = $(this);
    var $shadeGrid = $product.find('.js-product-full-shades-grid');
    var $items = $shadeGrid.find('.js-product-full-shades-grid-item');

    $items.each(function () {
      var $this = $(this);
      var enableReorder = $this.closest($shadeGrid).find($items).length > 1;
      var skuBaseId = $this.data('sku-base-id');
      var currentInvStatus = $this.data('inventoryStatus');
      var skuDataL2 = prodcat.data.getSku(skuBaseId);
      var invStatus;

      $this
        .filter('.js-product-full-shades-overlay-list-item')
        .addClass('shade-inv-status--' + currentInvStatus);

      if (!skuDataL2) {
        if (currentInvStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }

        return;
      }

      invStatus = skuDataL2.INVENTORY_STATUS;
      if (currentInvStatus === invStatus && invStatus !== 1 && enableReorder) {
        $this.closest($shadeGrid).append($this);
      }
      // Update Shade Inventory Status
      if (parseInt(currentInvStatus, 10) !== parseInt(invStatus, 10)) {
        $this.removeClass('shade-inv-status--' + currentInvStatus);
        $this.addClass('shade-inv-status--' + invStatus);
        $this.attr('data-inventory-status', invStatus).data('inventoryStatus', invStatus);
        if (invStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }
      }
    });
  });

  Drupal.behaviors.productFullShadesV2 = {
    toggleShade: false,
    drammingPage: false,
    attached: false,
    isDesktop: false,
    attach: function (context) {
      var self = this;
      var $templates = $('.js-product-full-shades-v2', context);

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.$addBtn = $('.js-add-to-cart', '.js-product-dramming');

      if ($('.js-second-shade-select-option').length) {
        self.drammingPage = true;
        self.$addBtn.addClass('button--disabled');
        self.$addBtn.data('disabled', true);
      }
      self.setIsDesktop();
      $templates.each(function () {
        var $template = $(this);

        self.initShadesCarousel($template);
        $(window).on(
          'resize',
          _.debounce(function () {
            self.initShadesCarousel($template);
            self.setIsDesktop();
            self.showPerfectMatchTabSelected(context);
            self.toggleExpand($template);
          }, 100)
        );
        self.setEvents($template);
      });

      $('.js-product-full-shade--filter').first().trigger('click');
      self.showPerfectMatchTabSelected(context);
    },

    orderAlphabetical: function (context) {
      var $list = $('.js-product-full-shades-overlay__list', context);
      var $listItem = $(
        '.js-product-full-data-shades .js-product-full-shades-overlay-list-item',
        context
      );

      $listItem
        .sort(function (a, b) {
          var aShade = $(a).data('shade-name');
          var bShade = $(b).data('shade-name');

          return aShade < bShade ? -1 : aShade > bShade ? 1 : 0;
        })
        .appendTo($list);
    },
    getSkuCountMax: function ($product) {
      const self = this;
      const defaultMaxCount = 21;

      if (!self.isDesktop) {
        /**
         *  If we are not on PC, styles force max count to 21
         *  no point in checking via JS.
         */
        return defaultMaxCount;
      }
      const $shadesGridWrapper = $('.js-product-full-shades-grid-content', $product);
      const $shadesGridItem = $(
        '.js-product-full-shades-grid-item:visible',
        $shadesGridWrapper
      ).first();

      const availableWidth = $shadesGridWrapper.width();
      // Add 4px difference due to styling, which is not counted right in JS.
      const availableHeight = $shadesGridWrapper.outerHeight(true) + 4;

      const swatchWidth = $shadesGridItem.outerWidth(true);
      const swatchHeight = $shadesGridItem.outerHeight(true);

      const maxcClumns = parseInt(availableWidth / swatchWidth, 10);
      const maxRows = parseInt(availableHeight / swatchHeight, 10);

      return parseInt(maxcClumns * maxRows, 10) || defaultMaxCount;
    },
    toggleExpand: function ($template) {
      var self = this;
      var $product = $template.closest('.js-product-full');
      var skuCount = $product.find('.js-product-full-shades-grid-item:visible').length;
      var $gridView = $product.find('.js-product-full-shades-grid-view');
      var $shadeDotsToggle = $('.js-product-full-shades__content-toggle', $product);

      $gridView.removeClass('expanded');
      // Keep track of how many shades are visible
      if (skuCount > self.getSkuCountMax($product)) {
        $shadeDotsToggle.removeClass('hidden');
      } else {
        $shadeDotsToggle.addClass('hidden');
      }
    },
    setEvents: function ($template) {
      var self = this;
      var $product = $template.closest('.js-product-full');
      var $shadesWrapper = $('.js-product-full-overlay-shades', $product);
      var $shadesGrid = $('.js-product-full-shades-grid', $product);
      var $shadesArray = $('.js-product-full-shades-array', $product);
      var $shadesGridItem = $('.js-product-full-shades-grid-item', $shadesGrid);
      var $shadesArrayItem = $('.js-product-full-shades-array-item', $shadesArray);
      var $shadesFilterItem = $('.js-product-full-shade--filter', $product);
      var $shadeHeader = $('.js-shades-header-title', $product);
      var $shadesTitle = $('.js-shades-title', $product);
      var $selectTitle = $('.js-select-title', $product);
      var $filterContainer = $('.js-shades-filter', $product);
      var $filterSet = $('.js-filter-set', $product);
      var $filterInfo = $('.js-filter-info', $product);
      var $filterwrapper = $('.js-filter-info-wrapper', $product);
      var $filterArrow = $('.js-filter-arrow', $product);
      var $shadesFlyout = $('.js-product-full-shades-flyout-v2', $product);
      var $ffCopy = $('.js-ff-personalization', $product);
      var $shadeName = $('.js-sku-shade-name', $product);
      var $shadeDot = $('.js-product-full-shades-overlay__selected-shade .js-shade-dot', $product);
      var $shadeDesc = $('.js-sku-shade-description', $product);
      var $shadeViewIcons = $('.js-shade-view-icons', $product);
      var $shadeGrid = $('.js-product-full-shades-list-view', $product);
      var $shadeList = $('.js-product-full-shades-grid-view', $product);
      var $selectedListItem;
      var $shadeDotsToggle = $('.js-product-full-shades__content-toggle', $product);
      var $shadeDotsDot = $('.js-product-full-shades-shade-dot', $product);
      var $shadeListExpand = $('.js-shades-list-expand', $product);
      var $selectedShadeToggle = $('.js-product-full-shades-overlay__selected-shade', $product);
      var $shadeToggleList = $('.js-product-full-shades-list', $product);
      var $shadeGridPerfectMatch = $('.js-product-full-overlay-perfectmatch', $product);
      var $shadeTabPerfectMatch = $('.js-product-full-shade--perfect-match', $product);
      var cr24 = !Drupal?.settings?.global_variables?.cr24 ? false : true;
      var $vtoBtns = $('.js-product-vto-btn, .js-product-foundation-vto-btn', $product);
      var $activeGridItems;
      var skuCount;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      // Select first shade if default sku isn't in stock
      $(function () {
        var $fullShades = $('.js-product-full-shades-v2', $product);
        var $items = $shadesGrid.find('.js-product-full-shades-grid-item');
        var hasActiveItem;

        $shadesGrid = $('.js-product-full-shades-grid-content', $fullShades);
        hasActiveItem = $items.filter('.active').length > 0;
        $items.each(function () {
          var $this = $(this);
          var skuBaseId = $this.data('sku-base-id');
          var skuData = prodcat.data.getSku(skuBaseId);
          var invStatus = skuData.INVENTORY_STATUS;
          var isOrderable = skuData.isOrderable;
          var defaultStatus = skuData.DEFAULT_SKU;
          var isRoutedSku = String(skuBaseId) === $product.attr('data-routed-sku-base-id');

          if (invStatus !== 1 && isOrderable === 0 && defaultStatus === 1 && !isRoutedSku) {
            if ($this.hasClass('active') || !hasActiveItem) {
              skuBaseId = $shadesGrid.find($shadesGridItem).first().data('sku-base-id');
              $product.trigger('product.skuSelect', skuBaseId).once();
              return false;
            }
          }
        });
      });

      $(document).on('productShade:toggleShadeTabs', function (e, perfectMatchTab) {
        if (perfectMatchTab === 'perfect_match') {
          $shadeGridPerfectMatch.show();
          $shadesWrapper.hide();
          $shadesFlyout.addClass('perfect-match-active');
        } else {
          $shadeGridPerfectMatch.hide();
          $shadesWrapper.show();
          $shadesFlyout.removeClass('perfect-match-active');
        }
      });

      site.restrict_navigation($filterSet);
      $filterwrapper.add($shadesGridItem).on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(this).trigger('click');
        }
      });

      //  Hide icons at 1 shade
      if ($shadesGrid.hasClass('js-singular-swatch')) {
        $shadeViewIcons.addClass('hidden');
      }

      $filterwrapper.once().on('click', function () {
        $selectTitle.add($shadesTitle).toggleClass('hidden');
        $shadeHeader.toggleClass('expanded');
        $filterSet.add($filterInfo).toggleClass('hidden');
        $filterArrow.toggleClass('rotated');
      });

      $shadesArrayItem.once().on('click', function (event) {
        event.preventDefault();
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');
        var $surplusItems = $this
          .closest('.js-product-full-shades-grid')
          .find($shadesArrayItem)
          .not($this);

        $shadesArrayItem.removeClass('hovered');

        if ($shadeList.hasClass('hidden') && $shadeGrid.parent().hasClass('list-box')) {
          $surplusItems.addClass('hidden');
          $shadeGrid.addClass('collapse');
          $shadeListExpand.removeClass('hidden');
        }

        // Restrict the second click on the same shade
        if ($this.hasClass('active')) {
          return;
        }
        $product.trigger('product.skuSelect', [skuBaseId, self.toggleShade]);
        self.loadSelectedShade(skuBaseId, $product);
        $shadesArrayItem.attr('aria-selected', false);
        $this.attr('aria-selected', true);
        $ffCopy.removeClass('hidden');

        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      $shadeViewIcons.on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(this).trigger('click');
        }
      });

      $shadeListExpand.once().on('click', function () {
        self.collapseList($product, $shadeGrid, $shadeListExpand);
        $('.js-product-full-shades-overlay-list-item.active', $product).focus();
      });

      $shadeViewIcons.once().on('click', function () {
        var $this = $(this);

        // Restrict the second click on the same shade filter
        if ($this.hasClass('active')) {
          return;
        }

        $shadeViewIcons.removeClass('active');
        $this.toggleClass('active');
        $shadeGrid.toggleClass('hidden');
        $shadeList.toggleClass('hidden').parent().toggleClass('list-box');

        if ($shadeGrid.hasClass('collapse')) {
          setTimeout(function () {
            self.collapseList($product, $shadeGrid, $shadeListExpand);
          }, 100);
        }
        // Scroll into view selection in list mode
        if ($shadeList.parent().hasClass('list-box')) {
          $shadeGrid
            .last()
            .find('.js-product-full-shades-overlay-list-item.active')
            .get(0)
            .scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
        }
      });

      if (canHover) {
        $shadesArrayItem.on('mouseover', function () {
          var $this = $(this);
          var skuBaseId = $this.data('sku-base-id');
          var skuData = prodcat.data.getSku(skuBaseId);

          // Restrict the second hover on the same shade
          if ($this.hasClass('hovered')) {
            return;
          }
          $shadesArrayItem.removeClass('hovered');
          $this.addClass('hovered');
          $ffCopy.addClass('hidden');
          $shadeName.html(skuData['SHADENAME']);
          $shadeDesc.html(skuData['SHADE_DESCRIPTION']);
          $shadeDot.css({ backgroundColor: skuData['HEX_VALUE_STRING'] });

          if (self.drammingPage) {
            self.toggleShade = !self.toggleShade;
          }
        });

        $shadesArrayItem.on('mouseleave', function () {
          $shadesArrayItem.removeClass('hovered');
          $ffCopy.removeClass('hidden');
        });
      }

      $shadeTabPerfectMatch.once().on('click tab', function () {
        var $perfectMatchTab = $(this);
        var $parentPerfectMatchTab = $perfectMatchTab.closest('.js-product-full-shades-flyout-v2');
        var $productFullPerfectMatch = $parentPerfectMatchTab.find(
          '.js-product-full-perfect-match'
        );
        var skuBaseId = $productFullPerfectMatch.attr('data-sku-base-id');

        $product.trigger('product.skuSelect', skuBaseId);
        $perfectMatchTab.trigger('productShade:choosePerfectMatch');
      });

      $shadeTabPerfectMatch.on('productShade:choosePerfectMatch', function () {
        var $shadesTabsFlyout = $('.js-product-full-shade--filter', $shadesFlyout);

        $shadesTabsFlyout.removeClass('active');
        $(document).trigger('productShade:toggleShadeTabs', ['perfect_match']);
        $(this).addClass('active');
      });

      $shadesFilterItem.on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(this).trigger('click');
        }
      });

      $shadesFilterItem.once().on('click', function (e) {
        var $tab = $(this);
        var colorFamily = $tab.data('filter');
        var selectedFilter = $tab.contents().not($tab.children()).text();

        e.preventDefault();

        $shadeList.removeClass('expanded');
        $('.js-product-full-shade--perfect-match').removeClass('active');
        $(document).trigger('productShade:toggleShadeTabs');
        $product.trigger('product.showColorFamily', [colorFamily]);
        $shadeGrid.removeClass('collapse');
        $shadeListExpand.addClass('hidden');
        $filterSet.add($selectTitle).addClass('hidden');
        $shadeHeader.removeClass('expanded');
        $shadesTitle.add($filterInfo).removeClass('hidden');
        $('.js-filter-selected', $filterInfo).text(selectedFilter);
        $filterArrow.removeClass('rotated');
        $shadesFilterItem.attr('aria-selected', false);
        $tab.attr('aria-selected', true);
        skuBaseId = $tab.data('sku-base-id');
        $selectedListItem = $shadesGrid.find(
          '.js-product-full-shades-overlay-list-item[data-sku-base-id="' + skuBaseId + '"]'
        );

        // Keep track of how many shades are visible
        if (skuCount > self.getSkuCountMax($product)) {
          $shadeDotsToggle.removeClass('hidden');
        } else {
          $shadeDotsToggle.addClass('hidden');
        }

        // Scroll into view selection in list mode
        if ($shadeList.parent().hasClass('list-box')) {
          $selectedListItem.filter('.active:visible').get(0).scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });

      $(document).on('product.showColorFamily', '.js-product', function (e, colorFamily) {
        var defaultFamily = 'all';
        var selectedColorFamily;
        var $selectedShade = $shadesGrid.find('.js-product-full-shades-grid-item.active').first();
        var skuBaseId = $selectedShade.data('sku-base-id');
        var $overlayListItem = $('.js-product-full-shades-overlay-list-item', $shadesFlyout);
        $shadesFilterItem.removeClass('active');
        $shadesFilterItem.each(function () {
          selectedColorFamily = $(this).data('filter');
          if (
            typeof selectedColorFamily !== typeof undefined &&
            selectedColorFamily === colorFamily
          ) {
            $(this).addClass('active');
          }
        });
        $shadesGridItem.removeClass('hidden');

        if (colorFamily !== defaultFamily) {
          $shadesGridItem.each(function () {
            var $shade = $(this);
            var shadeFamily = $shade.data('shade-family');

            if (shadeFamily) {
              shadeFamily = shadeFamily.replace(/\s+/g, '').toLowerCase().split(',');
              if (shadeFamily.indexOf(colorFamily.toLowerCase()) === -1) {
                $shade.addClass('hidden');
              }
            }
          });
        }
        if ($('body').hasClass('overlay-shades-active')) {
          $activeGridItems = $shadesFlyout.find($shadesGridItem);

          // Mobile Overlay Filter shows active shade
          if ($activeGridItems.filter(':visible').hasClass('active')) {
            $shadesFlyout.scrollTop(0);
            setTimeout(function () {
              $shadesFlyout.animate(
                {
                  scrollTop:
                    $overlayListItem.filter('.active:visible').last().position().top +
                    $shadesFlyout.scrollTop()
                },
                'slow'
              );
            }, 300);
          }
        } else {
          $activeGridItems = $template.find($shadesGridItem);
        }
        skuCount = $activeGridItems.filter(':visible').length;
        $('.js-sku-count', $filterInfo).text('(' + skuCount + ')');
        $('.js-sku-count', $filterContainer).text('');
        $('.js-product-full-shade--filter.active', $filterContainer)
          .find('.js-sku-count')
          .text('(' + skuCount + ')');
        self.loadSelectedShade(skuBaseId, colorFamily, $product, $shadesFilterItem);
        Drupal.behaviors.productFullShadesV2.initShadesCarousel($template);
      });

      if (canHover) {
        $shadesArray.on('mouseleave', function () {
          var skuBaseId = $product.data('sku-base-id');
          var skuData = prodcat.data.getSku(skuBaseId);

          $ffCopy.removeClass('hidden');
          $shadeName.html(skuData['SHADENAME']);
          $shadeDesc.html(skuData['SHADE_DESCRIPTION']);
          $shadeDot.css({ backgroundColor: skuData['HEX_VALUE_STRING'] });
        });
      }

      if (cr24 === true) {
        $activeGridItems = $template.find($shadesGridItem);
        skuCount = $activeGridItems.filter(':visible').length;
        $shadeDotsToggle.addClass('hidden');
        $selectedListItem = $shadeToggleList.find('.js-product-full-shades-list-item');

        if (skuCount > self.getSkuCountMax($product)) {
          $shadeDotsToggle.removeClass('hidden');
        }
        $shadeDotsToggle.once().on('click', function () {
          $shadeList.toggleClass('expanded');
        });
        $selectedShadeToggle.once().on('click', function () {
          if ($shadeToggleList.hasClass('hidden')) {
            $shadeToggleList.removeClass('hidden');
            $shadeToggleList
              .last()
              .find('.js-product-full-shades-overlay-list-item.active')
              .get(0)
              .scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });
          } else {
            $shadeToggleList.addClass('hidden');
          }
        });
        $shadesArray.once().on('click', function () {
          $shadeToggleList.addClass('hidden');
        });
        $shadeDotsDot.on('mouseover', function () {
          $shadeToggleList.addClass('hidden');
        });

        /**
         * VTO CTA BUTTONS
         */
        if ($vtoBtns.length > 0) {
          $vtoBtns.removeClass('hidden');
        }
        // Emit an event when VTO CTA buttons are clicked so other modules can react
        $vtoBtns.on('click', function () {
          var currentSkuBaseId =
            $product.data('sku-base-id') || prodcat.ui.getSkuIdByProduct($product);
          var currentSku = prodcat.data.getSku(currentSkuBaseId) || {};

          var payload = {
            skuBaseId: currentSkuBaseId,
            productId: currentSku.PRODUCT_ID,
            shadeName: currentSku.SHADENAME
          };

          // Trigger on the product element so delegated listeners scoped to `.js-product` receive it
          $product.trigger('product:vtoCtaClicked', [payload]);
        });

        if (self.isDesktop && $filterContainer) {
          const $tabSlider = $('.js-product-full-shades-filters', $product);
          let isDown = false;
          let startX;
          let scrollLeft;

          $tabSlider
            .once()
            .on('mousedown', function (e) {
              isDown = true;
              $tabSlider.addClass('active');
              startX = e.pageX - $tabSlider.offset().left;
              scrollLeft = $tabSlider.scrollLeft();
            })
            .on('mouseleave', function () {
              isDown = false;
              $tabSlider.removeClass('active');
            })
            .on('mouseup', function () {
              isDown = false;
              $tabSlider.removeClass('active');
            })
            .on('mousemove', function (e) {
              if (!isDown) {
                return;
              }
              e.preventDefault();
              const x = e.pageX - $tabSlider.offset().left;
              const walk = (x - startX) * 1; // scroll-speed

              $tabSlider.scrollLeft(scrollLeft - walk);
            });
        }
      } else {
        return;
      }
      $(document).trigger('product.colorFamilyLoaded');
    },
    setIsDesktop: function () {
      const self = this;
      const currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      const bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);

      self.isDesktop = currentBpWidth >= bPportraitUp;
    },
    initShadesCarousel: function ($container) {
      var self = this;
      var $shadesItem = $('.js-product-full-shades-grid-item:not(.hidden)', $container);
      var $shadesGrid = $('.js-product-full-shades-grid', $container);
      var $shadesGridView = $('.js-product-full-shades-grid-view', $container);
      var $shadesListView = $('.js-product-full-shades-list-view', $container);
      var isListSelected = $shadesGridView.hasClass('hidden');
      var isMobileOnce = $shadesGridView.hasClass('js-check-mob');
      var shadesItemLength = $shadesGridView.find($shadesItem).length;
      var shadesItemWidth = $shadesGridView.find($shadesItem).first().outerWidth(true);
      var shadesgridWidth = shadesItemLength * shadesItemWidth;
      var cr24 = !Drupal?.settings?.global_variables?.cr24 ? false : true;

      $shadesGrid.width('');

      if (!self.isDesktop && isListSelected) {
        $shadesGridView.toggleClass('hidden');
        $shadesListView.toggleClass('hidden');
        $shadesGridView.toggleClass('js-check-mob');
      }

      if (self.isDesktop) {
        if (shadesItemLength <= 20) {
          $shadesGrid.addClass('shade-swatch--large');
          if (shadesItemLength === 1) {
            $shadesGrid.addClass('js-singular-swatch');
          }
        } else {
          $shadesGrid.removeClass('shade-swatch--large');
        }

        if (!isListSelected && isMobileOnce) {
          $shadesGridView.toggleClass('hidden');
          $shadesListView.toggleClass('hidden');
          $shadesGridView.removeClass('js-check-mob');
        }

        return;
      }

      if (cr24 === false) {
        if (shadesItemLength >= 6) {
          $shadesGrid.width(shadesgridWidth);
        }
      }
    },

    loadSelectedShade: function (skuBaseId, colorFamily, $product, $shadesFilterItem) {
      var skuData = prodcat.data.getSku(skuBaseId);
      var shadeName = _.result(skuData, 'SHADENAME');
      var shadeRouteName = prodcat.ui.generateShadePath(skuBaseId);

      if (!$shadesFilterItem) {
        history.replaceState({}, shadeName, shadeRouteName);
        return;
      }

      if (colorFamily !== $shadesFilterItem.first().text()) {
        if ($product.hasClass('product-full')) {
          history.replaceState({}, colorFamily, '#/family/' + colorFamily);
        }
      } else {
        history.replaceState({}, colorFamily, '#');
      }
    },

    collapseList: function ($product, $shadeGrid, $shadeListExpand) {
      var filterActive = $('.js-product-full-shade--filter.active').data('filter');

      $shadeGrid.removeClass('collapse');
      $shadeListExpand.addClass('hidden');
      $product.trigger('product.showColorFamily', [filterActive]);
    },

    showPerfectMatchTabSelected: function (context) {
      var self = this;
      var $productFullShade = $('.js-product-full-shades-v2', context);
      var $product = $productFullShade.closest('.js-product');
      var $hasPerfectMatch = $product.hasClass('contains-recommendation');
      var $shadesFlyout = $('.js-product-full-shades-flyout-v2', $product);
      var $shadeTabPerfectMatch = $('.js-product-full-shade--perfect-match', $shadesFlyout);

      if (!self.isDesktop && Boolean($hasPerfectMatch) && $shadeTabPerfectMatch.length > 0) {
        $shadeTabPerfectMatch.trigger('productShade:choosePerfectMatch');
      } else {
        $('.js-product-full-shade--filter', $productFullShade).first().trigger('click');
      }
    }
  };
})(jQuery);
